// extracted by mini-css-extract-plugin
module.exports = {"themeToggle":"_3c64022e flex items-center pointer"};